import { render, staticRenderFns } from "./RecipeLinks.vue?vue&type=template&id=4d2409f8"
import script from "./RecipeLinks.vue?vue&type=script&lang=js"
export * from "./RecipeLinks.vue?vue&type=script&lang=js"
import style0 from "./RecipeLinks.vue?vue&type=style&index=0&id=4d2409f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports